import { render, staticRenderFns } from "./LegendPieChart.vue?vue&type=template&id=5793c948&scoped=true"
import script from "./LegendPieChart.vue?vue&type=script&lang=js"
export * from "./LegendPieChart.vue?vue&type=script&lang=js"
import style0 from "./LegendPieChart.vue?vue&type=style&index=0&id=5793c948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5793c948",
  null
  
)

export default component.exports